import { useCallback, useEffect, useState } from "react";
import wpPostsService from "../wpPostsService";
import { WPPostsFilter } from "../interface";
import { AxiosResponse } from "axios";
import { Post } from "@base/types/wp";

const useGetPosts = (filter: WPPostsFilter, enabled = true) => {
  const [data, setData] = useState<AxiosResponse<Post[]>>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return wpPostsService.getPosts(filter);
  }, [filter]);

  const transformResponse = useCallback(
    (response: AxiosResponse<Post[]>) => {
      if (response) {
        setData(response);
      }
    },
    [filter],
  );

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, error, isLoading, refetch };
};

export default useGetPosts;
